/**
 * 门户状态管理 - 管理登录/注册/搜索/试用弹窗显隐和表单模式切换
 */
import { LoginStateEnum } from './components/useLogin'

// 弹窗类型
export enum ModalType {
  NONE = 'NONE',
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  FORGET_PASSWORD = 'FORGET_PASSWORD',
  SEARCH = 'SEARCH',
  TRIAL = 'TRIAL'
}

// 导航锚点
export type NavAnchor =
  | 'home'
  | 'claw'
  | 'products'
  | 'solutions'
  | 'partners'
  | 'help-center'
  | 'about'
  | 'contact'

const currentModal = ref<ModalType>(ModalType.NONE)
const activeNav = ref<NavAnchor>('home')

export function usePortalState() {
  // ===== 弹窗管理 =====
  function openLoginModal() {
    currentModal.value = ModalType.LOGIN
  }

  function openRegisterModal() {
    currentModal.value = ModalType.REGISTER
  }

  function openForgetPasswordModal() {
    currentModal.value = ModalType.FORGET_PASSWORD
  }

  function openSearchModal() {
    currentModal.value = ModalType.SEARCH
  }

  function openTrialModal() {
    currentModal.value = ModalType.TRIAL
  }

  function closeModal() {
    currentModal.value = ModalType.NONE
  }

  /** 从注册弹窗切换到登录弹窗 */
  function switchToLogin() {
    currentModal.value = ModalType.LOGIN
  }

  /** 从登录弹窗切换到注册弹窗 */
  function switchToRegister() {
    currentModal.value = ModalType.REGISTER
  }

  const getCurrentModal = computed(() => currentModal.value)
  const isLoginModal = computed(() => currentModal.value === ModalType.LOGIN)
  const isRegisterModal = computed(() => currentModal.value === ModalType.REGISTER)
  const isForgetPasswordModal = computed(() => currentModal.value === ModalType.FORGET_PASSWORD)
  const isSearchModal = computed(() => currentModal.value === ModalType.SEARCH)
  const isTrialModal = computed(() => currentModal.value === ModalType.TRIAL)
  const isAnyModalOpen = computed(() => currentModal.value !== ModalType.NONE)

  // ===== 导航管理 =====
  function setActiveNav(anchor: NavAnchor) {
    activeNav.value = anchor
  }

  const getActiveNav = computed(() => activeNav.value)

  // ===== 免费试用 =====
  function showTrialModal() {
    currentModal.value = ModalType.TRIAL
  }

  return {
    // 弹窗方法
    openLoginModal,
    openRegisterModal,
    openForgetPasswordModal,
    openSearchModal,
    openTrialModal,
    closeModal,
    switchToLogin,
    switchToRegister,
    showTrialModal,
    // 弹窗状态
    getCurrentModal,
    isLoginModal,
    isRegisterModal,
    isForgetPasswordModal,
    isSearchModal,
    isTrialModal,
    isAnyModalOpen,
    // 导航
    setActiveNav,
    getActiveNav
  }
}
